import React, { useEffect } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { ArrowLeft } from "react-bootstrap-icons";
import styles from "./BlogPosts.module.scss";
import { Link } from "react-router-dom";
import Image from "../Image/Image";
import ShareLinks from "../ShareLinks/ShareLinks";
import MetaTags from "./MetaTags";
import AOS from "aos";
import "aos/dist/aos.css";

import header from "../../assets/images/blogs/blog14/header.jpg";
import body2 from "../../assets/images/blogs/blog14/body2.jpg";
import body3 from "../../assets/images/blogs/blog14/body3.jpg";
import body4 from "../../assets/images/blogs/blog14/body4.jpg";

// meta tags

// og image 1200px X 630px
import ogImage from "../../assets/images/blogs/blog14/og_image.png";

const config = {
  title: "Back on the track for little heroes",
  subtitle: "Štafeta srcem 2025 💙",
  dateCreated: "9.Jun 2025",
  metaTitle: "Nearshore GM | Back on the track for little heroes",
  siteName: "Nearshore GM",
  keywords:
    "software engineers, software developer, software company, flyeralarm, IT, Nis, Serbia, stafeta srcem, relay, running",
  // update this
  description:
    " Once again, our team proudly took part in the Štafeta srcem, organized by AMD.",
  url: "https://www.nearshoregm.com/insights/relay-with-heart",
  type: "article",
  ogImage: ogImage,
};
// meta tags end
const BlogPost10 = () => {
  useEffect(() => {
    AOS.init({ duration: 900 });
  }, []);
  return (
    <div className={styles.page} data-aos="fade-up">
      <MetaTags config={config} />
      <figure className={styles.hero_image_holder}>
        <Container>
          <Row>
            <Col md={12}>
              <div className={styles.filter}></div>
              <Image
                url={header}
                alt={config.title}
                className={`img-fluid ${styles.image}`}
              />
              <div className={styles.info}>
                <Container>
                  <Row>
                    <Col md={12}>
                      <div className={styles.date_share}>
                        <span className={styles.date}>
                          {config.dateCreated}
                        </span>
                        <ShareLinks shareUrl={config.url} />
                      </div>
                    </Col>
                  </Row>
                </Container>
              </div>
              <div className={styles.title_holder}>
                <Container>
                  <Row>
                    <Col md={12}>
                      <h1 className={styles.title}>{config.title}</h1>
                      <h3 className={styles.subtitle}>{config.subtitle}</h3>
                    </Col>
                  </Row>
                </Container>
              </div>
            </Col>
          </Row>
        </Container>
      </figure>
      <div className={styles.post_body}>
        <Container>
          <Row>
            <Col md={12}>
              <div className={styles.wraper}>
                <p className={styles.text}>
                    Once again, our team proudly took part in the "Štafeta srcem", organized by AMD.
                    A beautiful setting, great energy, and a meaningful cause—supporting the vital work of NURDOR Serbia.
                    Sore muscles today, but absolutely worth it. See you at the next one!
                </p>
                <div
                  className={`${styles.body_image_holder} `}
                >
                  <img
                    src={body2}
                    alt={config.title}
                    className={`${styles.body_image} img-fluid`}
                  />
                 
                </div>
                 <div
                  className={`${styles.body_image_holder} `}
                >
                <img
                    src={body3}
                    alt={config.title}
                    className={`${styles.body_image} img-fluid`}
                  />
                </div>
                <div
                  className={`${styles.body_image_holder} `}
                >
                  <img
                    src={body4}
                    alt={config.title}
                    className={`${styles.body_image} img-fluid`}
                  />
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <div className={styles.back_link_holder}>
        <Container>
          <Row>
            <Col md={12}>
              <Link to="/insights" className={styles.back_link}>
                <ArrowLeft className={styles.icon} />
                Back
              </Link>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default BlogPost10;
